import { z } from 'zod';

/**
 * Push device registration (M4.2). The client posts its FCM registration
 * token after login; the server stores it against the authenticated user and
 * fans out generic push payloads on every notification-bell event.
 */
export const DEVICE_PLATFORMS = ['android', 'ios', 'web'] as const;
export type DevicePlatform = (typeof DEVICE_PLATFORMS)[number];

export const registerDeviceRequestSchema = z.object({
  // FCM tokens are ~150–300 chars today; the cap is generous headroom and
  // guards the column / payload size without rejecting legitimate tokens.
  token: z.string().min(1, 'token is required').max(4096),
  platform: z.enum(DEVICE_PLATFORMS).default('android'),
});
export type RegisterDeviceRequest = z.infer<typeof registerDeviceRequestSchema>;

export interface RegisterDeviceResponse {
  registered: boolean;
}

export interface RemoveDeviceResponse {
  removed: boolean;
}
